import { type PimProductV11 } from '@redteclab/api/clients/bully'

/**
 * pharmaObl means "required to be sold by a pharmacy"
 * @param product
 */
export const productAccessorPharmaOblFlagIsTrue = (
  product: PimProductV11,
): boolean => {
  return product.flags?.pharma_obl.active === true
}
